<template lang="pug">
  article.pt-164.md-pt-120
    transition(name="fade")
      main(v-if="doc")
        breadcrumb-nav(:items="nav")
        header.mb-120
          //- title
          container(width="md")
            .text-24(v-html="doc.acf.header")
          //- page nav
          nav.px-30.mt-50.cursor-pointer.flex.justify-center(v-if="doc.acf.artworks")
            router-link.flex-1.flex-grow.sm-flex-none.block(:to="{name: 'blue-project'}")
              btn.sm-min-w-btn(:active="!$route.name.includes('artworks') && !$route.name.includes('installation')") Overview
            router-link.flex-1.flex-grow.sm-flex-none.block.-ml-px(:to="{name: 'blue-project/artworks'}")
              btn.sm-min-w-btn(:active="$route.name.includes('artworks')") Artworks
            router-link.flex-1.flex-grow.sm-flex-none.block.-ml-px(v-if="doc.acf.installation" :to="{name: 'blue-project/installation'}")
              btn.sm-min-w-btn(:active="$route.name.includes('installation')") Installation
        section
          transition(name="pagefade")
            router-view(:doc="doc")
</template>

<script>
import BreadcrumbNav from '@/components/BreadcrumbNav'
import Container from '@/components/Container'
import Btn from '@/components/Btn'
import { plainTitle } from '@/utils'
export default {
  name: 'BlueProject',
  props: ['slug'],
  data () {
    return {
      doc: null
    }
  },
  computed: {
    nav () {
      return [
        { txt: 'Blue Projects', rt: '/blue-projects' },
        { txt: this.doc.acf.title_main, rt: { name: 'blue-project', params: { slug: this.$route.params.slug } } },
        { txt: this.$route.meta.label }
      ]
    }
  },
  methods: {
    async getDoc () {
      const qry = this.$route.query
      if (qry.id && qry.preview) return this.$store.dispatch('getPreview', { type: 'blue-projects', ...qry })
      return this.$store.dispatch('getBlueProject', this.slug)
    }
  },
  created () {
    this.getDoc().then(doc => { this.doc = doc })
  },
  components: { BreadcrumbNav, Container, Btn },
  metaInfo () {
    if (!this.doc) return
    const title = plainTitle(this.doc)
    return {
      title: title,
      meta: this.$store.getters.meta({ title: title })
    }
  }
}
</script>

<style>
</style>
